import { lazy, Suspense, useEffect, useState } from "react";
import type { Snapshot } from "../../api";
import { OPEN_RECORD_EVENT, isRecordKind, type RecordRef } from "./recordEvents";

const RecordDrawer = lazy(() => import("./RecordDrawer").then((m) => ({ default: m.RecordDrawer })));

/**
 * Mounted once by the shell: listens for openRecord() and shows the record
 * in the right-side panel over whatever list is on screen. The panel's code
 * loads the first time a record is opened. One record at a time; opening
 * another replaces it.
 */
export function RecordHost({ s, go, canOpenPage }: { s: Snapshot; go: (page: string) => void; canOpenPage: (page: string) => boolean }) {
  const [open, setOpen] = useState<RecordRef | null>(null);
  useEffect(() => {
    const on = (e: Event) => {
      const ref = (e as CustomEvent<RecordRef>).detail;
      if (ref && isRecordKind(ref.kind) && typeof ref.id === "string" && ref.id) setOpen({ ...ref });
    };
    window.addEventListener(OPEN_RECORD_EVENT, on);
    return () => window.removeEventListener(OPEN_RECORD_EVENT, on);
  }, []);
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <RecordDrawer key={`${open.kind}:${open.id}`} s={s} r={open} onClose={() => setOpen(null)} go={go} canOpenPage={canOpenPage} />
    </Suspense>
  );
}
